import React, { useState, useEffect, useRef } from 'react';

const Timer = ({ initialTime }) => {
  const [timer, setTimer] = useState(initialTime);
  const [timerActive, setTimerActive] = useState(false);
  const intervalRef = useRef(null);

  // Format time for display
  const formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    return `${minutes}:${remainingSeconds < 10 ? '0' : ''}${remainingSeconds}`;
  };

  // Handle timer logic
  useEffect(() => {
    if (timerActive && timer > 0) {
      intervalRef.current = setInterval(() => {
        setTimer(prevTimer => {
          if (prevTimer <= 1) {
            clearInterval(intervalRef.current);
            setTimerActive(false);
            return 0;
          }
          return prevTimer - 1;
        });
      }, 1000);
    }

    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    };
  }, [timerActive]);

  // Handle component unmounting
  useEffect(() => {
    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    };
  }, []);

  return (
    <div className="timer">
      <h4>Timer: {formatTime(timer)}</h4>
      {!timerActive && timer > 0 && (
        <button onClick={() => setTimerActive(true)} className="timer-button">
          Start Timer
        </button>
      )}
    </div>
  );
};

export default Timer;
